"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/Conversation/JumpBtn.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _NewMessagesMarker = require('./NewMessagesMarker');







/* A labelled pill at the right padding edge of the pane, floating over the
 * history just above the composer. */
const JumpBtn = ({ style, onClick, unreadMessagesCount }) => (
  _react2.default.createElement('div', { className: "conversation-box--jump-btn--wrapper", style: style, __self: this, __source: {fileName: _jsxFileName, lineNumber: 13}}
    , _react2.default.createElement('div', { className: "conversation-box--jump-btn--column", __self: this, __source: {fileName: _jsxFileName, lineNumber: 14}}
      , _react2.default.createElement('button', {
        type: "button",
        className: "conversation-box--jump-btn",
        onClick: onClick, __self: this, __source: {fileName: _jsxFileName, lineNumber: 15}}

        , _react2.default.createElement('i', { className: "material-icons", 'aria-hidden': "true", __self: this, __source: {fileName: _jsxFileName, lineNumber: 20}}, "arrow_downward")
        ,  unreadMessagesCount ? _NewMessagesMarker.newMessagesLabel.call(void 0, unreadMessagesCount) : 'Jump to latest' 
      )
    )
  )
)

exports. default = JumpBtn
